<div class="outside-container col ">
    
    <div class="container">
        <div class=" d-flex justify-content-center bold">User Configuration</div>
        </div> 